import { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
// import Header from "../../shared/Header";

interface Props {
  status: Boolean;
}

// eslint-disable-next-line
const MainLayout: FC<Props> = ({ status }) => {
  const currLocation = window.location.pathname + window.location.search;
  return status ? (
    <>
      {/* <Header isEnable /> */}
      <Outlet />
    </>
  ) : (
    <Navigate to={`/?redirectTo=${currLocation}`} />
  );
};
export default MainLayout;
